import { INFORMATION_PATH } from 'rollouts/navigation';

module.exports = {
  path: INFORMATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/RolloutInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/rollouts/routes/show/routes/information/index.js